/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

import { Element } from './Element';
import { Hit } from './Hit';
import { MathUtils } from './MathsUtils';
import { Vector2 } from 'three';

export class ElementCircle implements Element {
  private element: any;
  private center: Vector2;
  private radius: number;
  constructor(elem: any, ballRadius: number) {
    this.element = elem;
    this.center = new Vector2(elem.center[0], elem.center[1]);
    this.radius = elem.radius;
  }

  checkHit (point: Vector2, dir: Vector2, ballRadius: number): Hit {
    return MathUtils.checkCircleHit(point, dir, this.center, this.radius + ballRadius);
  }
}
